// src/components/SidebarRight.js
import React from 'react';
import { Card, CardContent, Typography, Avatar, Grid, Chip, Divider } from '@mui/material';

export default function SidebarRight() {
    return (
        <div>

            <Typography variant="h6" gutterBottom>
                最近动态
            </Typography>
            {/* 谁查看了我的简历 */}
            <Card sx={{ marginBottom: 2 }}>
                <CardContent>
                    <Typography variant="h6">谁查看了我的简历</Typography>
                    <Typography variant="body2" color="text.secondary">
                        公司A、公司B 最近查看了你的简历
                    </Typography>
                </CardContent>
            </Card>

            {/* 推荐关注 */}
            <Card sx={{ marginBottom: 2 }}>
                <CardContent>
                    <Typography variant="h6">推荐关注</Typography>
                    <Typography variant="body2" color="text.secondary">
                        推荐关注的公司或行业专家列表...
                    </Typography>
                </CardContent>
            </Card>



            {/* 广告位 */}
            <Card sx={{ marginBottom: 2 }}>
                <CardContent>
                    <Typography variant="h6">广告位</Typography>
                    <Typography variant="body2" color="text.secondary">
                    广告位...
                    </Typography>
                </CardContent>
            </Card>

            {/* 热门标签 */}
            <Card>
                <CardContent>
                    <Typography variant="h6">热门标签</Typography>
                    <div>
                        <Chip label="JavaScript" sx={{ margin: 0.5 }} />
                        <Chip label="Vue.js" sx={{ margin: 0.5 }} />
                        <Chip label="区块链" sx={{ margin: 0.5 }} />
                        <Chip label="远程工作" sx={{ margin: 0.5 }} />
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
